// Import Libraries
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
import { gsap } from 'gsap'

try {
    //Loaders
    var sceneReady = false
    var loadingBarElement = document.querySelector('.loading-bar')
    var loadingManager = new THREE.LoadingManager(
        // Loaded
        () => {
            setTimeout(() => {
                document.querySelector('body').classList.remove('loading')
            }, 4000)
            
            

            // Wait a little
            window.setTimeout(() => {
                // Animate overlay
                gsap.to(overlayMaterial.uniforms.uAlpha, { duration: 3, value: 0, delay: 1 })

                // Update loadingBarElement
                loadingBarElement.classList.add('ended')
                loadingBarElement.style.transform = ''
            }, 500)

            window.setTimeout(() => {
                sceneReady = true
            }, 3000)
        },

        // Progress
        (itemUrl, itemsLoaded, itemsTotal) => {
            // Calculate the progress and update the loadingBarElement
            var progressRatio = itemsLoaded / itemsTotal
            loadingBarElement.style.transform = `scaleX(${progressRatio})`
        }
    )
    var gltfLoader = new GLTFLoader(loadingManager)
    var cubeTextureLoader = new THREE.CubeTextureLoader(loadingManager)

} catch (error) {

}

// Setting a canvas
const canvas = document.querySelector('canvas.webgl')

// Creating a scene
const scene = new THREE.Scene()

// Loading Textures
const textureLoader = new THREE.TextureLoader()

const normalMap = textureLoader.load('/3d/textures/Normal.png')
const colorMap = textureLoader.load('/3d/textures/Color.jpg')
const colorMap2 = textureLoader.load('/3d/textures/Color2.jpg')
const colorMap3 = textureLoader.load('/3d/textures/Color3.jpg')
const colorMap4 = textureLoader.load('/3d/textures/Color4.jpg')
const colorMap5 = textureLoader.load('/3d/textures/Color5.jpg')
const metalnessMap = textureLoader.load('/3d/textures/Metallic.jpg')
const metalnessMap2 = textureLoader.load('/3d/textures/Metallic2.jpg')
const metalnessMap3 = textureLoader.load('/3d/textures/Metallic3.jpg')
const metalnessMap4 = textureLoader.load('/3d/textures/Metallic4.jpg')
const roughnessMap = textureLoader.load('/3d/textures/Roughness.jpg')
const roughnessMap2 = textureLoader.load('/3d/textures/Roughness2.jpg')
const emissiveMap1 = textureLoader.load('/3d/textures/Emissive1.jpg')
const emissiveMap2 = textureLoader.load('/3d/textures/Emissive2.jpg')

colorMap.colorSpace = THREE.SRGBColorSpace
colorMap2.colorSpace = THREE.SRGBColorSpace
colorMap3.colorSpace = THREE.SRGBColorSpace
colorMap4.colorSpace = THREE.SRGBColorSpace
colorMap5.colorSpace = THREE.SRGBColorSpace
colorMap.flipY = false
colorMap2.flipY = false
colorMap3.flipY = false
colorMap4.flipY = false
colorMap5.flipY = false
normalMap.flipY = false
metalnessMap.flipY = false
metalnessMap2.flipY = false
metalnessMap3.flipY = false
metalnessMap4.flipY = false
roughnessMap.flipY = false
roughnessMap2.flipY = false
emissiveMap1.flipY = false
emissiveMap2.flipY = false

colorMap.generateMipmaps = false
colorMap2.generateMipmaps = false
colorMap3.generateMipmaps = false
colorMap4.generateMipmaps = false
colorMap5.generateMipmaps = false
normalMap.generateMipmaps = false
emissiveMap1.generateMipmaps = false

// Materials
const boxMaterial = new THREE.MeshStandardMaterial({
    map: colorMap,
    roughnessMap: roughnessMap,
    metalnessMap: metalnessMap,
    metalness: 1,
    envMapIntensity: 0.5,
    emissive: 0xffffff,
    emissiveMap: emissiveMap1,
    emissiveIntensity: 1,
})

const boxMaterial2 = new THREE.MeshStandardMaterial({
    map: colorMap2,
    roughnessMap: roughnessMap,
    metalnessMap: metalnessMap,
    metalness: 1,
    envMapIntensity: 0.5,
    emissive: 0xffffff,
    emissiveMap: emissiveMap1,
    emissiveIntensity: 1,

})

const boxMaterial3 = new THREE.MeshStandardMaterial({
    map: colorMap3,
    roughnessMap: roughnessMap,
    metalnessMap: metalnessMap,
    envMapIntensity: 0.5,
    metalness: 1,
})

const boxMaterial4 = new THREE.MeshStandardMaterial({
    map: colorMap4,
    roughnessMap: roughnessMap2,
    metalnessMap: metalnessMap3,
    metalness: 1,
    envMapIntensity: 0.5,
    emissive: 0xffffff,
    emissiveMap: emissiveMap1,
    emissiveIntensity: 1,
})

const boxMaterial5 = new THREE.MeshStandardMaterial({
    map: colorMap5,
    roughnessMap: roughnessMap,
    metalnessMap: metalnessMap,
    metalness: 1,
    envMapIntensity: 0.5,
    emissive: 0xffffff,
    emissiveMap: emissiveMap1,
    emissiveIntensity: 1,
})

let selectedChild
let activeModelName = 'device-lite'
let activeModel = null
let deviceLightModel = null
let deviceProModel = null

let liteSelectedMaterial = boxMaterial
let proSelectedMaterial = boxMaterial5

// Import Models
// const gltfLoader = new GLTFLoader()

function setupModelMaterials(obj) {
    let firstMesh = null

    obj.traverse((child) => {
        if (child.isMesh) {
            child.material = boxMaterial
            if (!firstMesh) {
                firstMesh = child
            }
        }
    })

    return firstMesh
}

function setupModel(obj, material) {
    let firstMesh = null

    obj.traverse((child) => {
        if (child.isMesh) {
            child.material = material
            if (!firstMesh) {
                firstMesh = child
            }
        }
    })

    return firstMesh
}

function loadModel(path, onLoaded) {
    gltfLoader.load(
        path,
        (gltf) => {
            const model = gltf.scene
            const firstMesh = setupModel(model, boxMaterial)
            onLoaded(model, firstMesh)
        },
        undefined,
        (error) => {
            console.error('Model load error:', path, error)
        }
    )
}

loadModel('/3d/models/device-lite.glb', (obj, firstMesh) => {
    deviceLightModel = obj
    deviceLightModel.visible = true
    activeModel = deviceLightModel

    if (firstMesh) {
        selectedChild = firstMesh
    }

    scene.add(deviceLightModel)
    updateMaterialButtonsByModel()
    updateAnnotationsByModel()
    updateModelLabel()
})

loadModel('/3d/models/device-pro.glb', (obj) => {
    deviceProModel = obj
    deviceProModel.visible = false
    scene.add(deviceProModel)
})

// Feature Points
const raycaster = new THREE.Raycaster()

const points = [
    {
        position: new THREE.Vector3(1.4, 0.65, 0.1),
        element: document.querySelector('.point-0')
    },
    {
        position: new THREE.Vector3(0.0, 0.8, 0.15),
        element: document.querySelector('.point-1')
    },
    {
        position: new THREE.Vector3(0.41, 0.4, 0.05),
        element: document.querySelector('.point-2')
    },
    {
        position: new THREE.Vector3(-0.88, 0.68, 0.1),
        element: document.querySelector('.point-3')
    },
    {
        position: new THREE.Vector3(-1.4, 0.65, 0.1),
        element: document.querySelector('.point-4')
    },
    {
        position: new THREE.Vector3(1.55, -0.2, -0.12),
        element: document.querySelector('.point-5')
    },
    {
        position: new THREE.Vector3(-1.62, 0.0, 0.0),
        element: document.querySelector('.point-6')
    },
    {
        position: new THREE.Vector3(1.2, -0.74, -0.32),
        element: document.querySelector('.point-7')
    },
    {
        position: new THREE.Vector3(-1.2, -0.74, -0.32),
        element: document.querySelector('.point-8')
    }
]

// Points Button
document.getElementById('annotations').addEventListener('click', function () {
    const points = document.querySelectorAll('.point');
    points.forEach(point => {
        if (point.style.display === 'none') {
            point.style.display = 'block';
        } else {
            point.style.display = 'none';
        }
    });
});

// Points Overlapping
function setListeners() {
    const pointerList = document.querySelectorAll('.point')
    pointerList.forEach(pointerElement => {
        const labelElement = pointerElement.querySelector('.label');
        labelElement.addEventListener('mouseover', event => {
            pointerElement.style.zIndex = 10
        })
        labelElement.addEventListener('mouseleave', event => {
            pointerElement.style.zIndex = 1
        })
    })
}



const tickTime = setInterval(() => {
    if (sceneReady) {
        clearInterval(tickTime)
        setListeners()
    }
    console.log("tickTime")
}, 1000)

//
// Toggle UI
//
const toggleUiButton = document.querySelector('#toggleUI')
const panel = document.querySelector('#panelShow')
toggleUiButton.addEventListener('click', (e) => {
    console.log(toggleUiButton)
    panel.classList.toggle('show')
})

const toggleModelButton = document.querySelector('#toggleModel')

toggleModelButton.addEventListener('click', () => {
    if (!deviceLightModel || !deviceProModel) return

    if (activeModelName === 'device-lite') {
        deviceLightModel.visible = false
        deviceProModel.visible = true
        activeModelName = 'device-pro'
        activeModel = deviceProModel
        applyMaterialToModel(deviceProModel, proSelectedMaterial)
        toggleModelButton.classList.add('pro')

        // обновляем selectedChild
        deviceProModel.traverse((child) => {
            if (child.isMesh) {
                selectedChild = child
            }
        })
    } else {
        deviceProModel.visible = false
        deviceLightModel.visible = true
        activeModelName = 'device-lite'
        activeModel = deviceLightModel
        activeModelName = 'device-lite'
        activeModel = deviceLightModel
        applyMaterialToModel(deviceLightModel, liteSelectedMaterial)
        toggleModelButton.classList.remove('pro')

        deviceLightModel.traverse((child) => {
            if (child.isMesh) {
                selectedChild = child
            }
        })
    }

    console.log('Active model:', activeModelName)
    toggleModelButton.classList.toggle('active')
    updateMaterialButtonsByModel()
    updateAnnotationsByModel()
    updateModelLabel()
})


function updateAnnotationsByModel() {
    const allPoints = document.querySelectorAll('.point')

    allPoints.forEach((point) => {
        const label = point.querySelector('.label')

        if (!point.dataset.originalLabel) {
            point.dataset.originalLabel = label.textContent
        }

        const original = parseInt(point.dataset.originalLabel)

        point.classList.remove('model-hidden')

        if (activeModelName === 'device-lite') {
            if (point.dataset.liteHidden === 'true') {
                point.classList.add('model-hidden')
                return
            }

            if (original > 3) {
                label.textContent = original - 1
            } else {
                label.textContent = original
            }
        } else {
            label.textContent = original
        }
    })
}

function updateModelLabel() {
    const modelLabel = document.querySelector('#modelLabel')
    if (!modelLabel) return

    if (activeModelName === 'device-pro') {
        modelLabel.textContent = 'Model: Pro'
    } else {
        modelLabel.textContent = 'Model: Basic'
    }
}


//
// Panel
//
const changeMaterialButtons = document.querySelectorAll('#panelShow button')
const body = document.querySelector('body')
console.log(changeMaterialButtons)

changeMaterialButtons.forEach((btn) => {
    btn.addEventListener('click', (e) => {
        console.log([e.target.dataset.material])
        const material = e.target.dataset.material
        let nextMaterial = null

        if (material == 'boxMaterial') {
            nextMaterial = boxMaterial
        }
        if (material == 'boxMaterial2') {
            nextMaterial = boxMaterial2
        }
        if (material == 'boxMaterial3') {
            nextMaterial = boxMaterial3
        }
        if (material == 'boxMaterial4') {
            nextMaterial = boxMaterial4
        }
        if (material == 'boxMaterial5') {
            nextMaterial = boxMaterial5
        }

        if (nextMaterial && activeModel) {
            applyMaterialToModel(activeModel, nextMaterial)

            if (activeModelName === 'device-lite') {
                liteSelectedMaterial = nextMaterial
            }

            if (activeModelName === 'device-pro') {
                proSelectedMaterial = nextMaterial
            }
        } else {
            console.error('No active model or material found');
        }
    })
})

function updateMaterialButtonsByModel() {
    const item1 = document.querySelector('#materialItem1')
    const item2 = document.querySelector('#materialItem2')
    const item3 = document.querySelector('#materialItem3')
    const item4 = document.querySelector('#materialItem4')
    const item5 = document.querySelector('#materialItem5')

    if (activeModelName === 'device-lite') {
        item1.style.display = 'flex'
        item2.style.display = 'flex'
        item3.style.display = 'flex'
        item4.style.display = 'none'
        item5.style.display = 'none'
    } else if (activeModelName === 'device-pro') {
        item1.style.display = 'none'
        item2.style.display = 'none'
        item3.style.display = 'none'
        item4.style.display = 'flex'
        item5.style.display = 'flex'
    }
}

function applyMaterialToModel(model, material) {
    if (!model) return

    let firstMesh = null

    model.traverse((child) => {
        if (child.isMesh) {
            child.material = material
            if (!firstMesh) {
                firstMesh = child
            }
        }
    })

    if (firstMesh) {
        selectedChild = firstMesh
    }
}

// Lights
const amblight = new THREE.AmbientLight(0x404040, 10); // soft white light
scene.add(amblight);

const directionalLightBack = new THREE.DirectionalLight(0xffffff, 3);
directionalLightBack.position.set(5, 5, 5)
scene.add(directionalLightBack)

const directionalLightFront = new THREE.DirectionalLight(0xffffff, 1);
directionalLightFront.position.set(-10, 3, -10)
scene.add(directionalLightFront)

// Environment Map
const rgbeLoader = new RGBELoader()
rgbeLoader.load('3d/textures/1.hdr', (environmentMap) => {
    environmentMap.mapping = THREE.EquirectangularReflectionMapping
    // scene.background = environmentMap
    scene.environment = environmentMap
})

// Viewport settings
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

// Viewport resizing
window.addEventListener('resize', () => {
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

// Camera
const camera = new THREE.PerspectiveCamera(25, sizes.width / sizes.height)
camera.position.set(-2, 5, -5)

scene.add(camera)

// Camera Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true
controls.maxPolarAngle = Math.PI / 1.95
controls.minDistance = 4
controls.maxDistance = 10
controls.enablePan = false


// Renderer
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    alpha: true,
    antialias: true,
})
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

// Animation
const tick = () => {
    // Update controls
    controls.update()

    // Update Camera Target
    camera.lookAt(new THREE.Vector3(0, 0, 0))

    if (sceneReady) { // Update feature points
        for (const point of points) {
            const screenPosition = point.position.clone()
            screenPosition.project(camera)

            raycaster.setFromCamera(screenPosition, camera)
            const intersects = activeModel ? raycaster.intersectObject(activeModel, true) : []

            if (intersects.length === 0) {
                point.element.classList.add('visible')
            }
            else {
                const intersectionDistance = intersects[0].distance
                const pointsDistance = point.position.distanceTo(camera.position)

                if (intersectionDistance < pointsDistance) {
                    point.element.classList.remove('visible')
                }
                else {
                    point.element.classList.add('visible')
                }
                // point.element.classList.remove('visible')
            }

            const translateX = screenPosition.x * sizes.width * 0.5
            const translateY = - screenPosition.y * sizes.height * 0.5
            point.element.style.transform = `translate(${translateX}px, ${translateY}px)`
        }

    }

    // Renderer
    renderer.render(scene, camera)
    window.requestAnimationFrame(tick)
}

tick()
